<template>
<div class="chapter">
<div class="inner_page">
<p style="page-break-before: always; text-align: justify">Vrijwaring</p>
<p style="text-align: justify">Hoewel de auteur en uitgever redelijkerwijs alles in het werk stelden om te zorgen dat de informatie in dit boek bij het ter perse gaan accuraat en actueel was, aanvaarden de auteur en uitgever geen enkele aansprakelijkheid, verplichting of verantwoordelijkheid voor enig verlies, schade of verstoring veroorzaakt door eventuele foutieve of onvolledige informatie, ongeacht of deze fouten ontstaan zijn door onachtzaamheid, ongeval of elke andere oorzaak.</p>
<p style="text-align: justify">De opgenomen teksten zijn louter informatief, en zijn niet bedoeld als vervanging van medische of zorgverlenende instanties. Lezers wordt aangeraden meerdere informatiebronnen te raadplegen, zoals de huisarts, diëtist of voedingsdeskundige. De informatie in dit boek geeft de opvattingen van de auteur weer en is niet specifiek gericht op één individueel persoon of bedrijf. De auteur aanvaardt geen verantwoordelijkheid of aansprakelijkheid voor enig verlies of schade, vermeend of anderzijds, veroorzaakt door de informatie of toepassing ervan in deze gids. One Jacked Monkey, LLC en de auteur zijn niet geassocieerd met of vertegenwoordigers van enig product of leverancier die in dit boek vermeld worden.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c003.vue?b94188b2